import "./FeedbackDialog.scss";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@mui/material";
import React, { useState } from "react";
import {
  setFeedbackDialogState,
  setMessageComment,
  setSelectedMessageIndex
} from "../redux/chatSlice";
import { useDispatch, useSelector } from "react-redux";

import { feedbackSubmitted } from "../segment/Events";

const FeedbackDialog = () => {
  const dispatch = useDispatch();

  const [feedback, setFeedback] = useState("");

  const dialogState = useSelector((state) => state.chat.feedbackDialogState);
  const selectedMessageIndex = useSelector(
    (state) => state.chat.selectedMessageIndex
  );

  const handleSubmit = () => {
    dispatch(
      setMessageComment({
        comment: feedback.trim(),
        messageIndex: selectedMessageIndex
      })
    );
    feedbackSubmitted(feedback.trim());
    handleClose();
  };

  const handleClose = () => {
    setFeedback("");
    dispatch(setFeedbackDialogState({ open: false, positive: null }));
    dispatch(setSelectedMessageIndex(null));
  };

  return (
    <Dialog className="dialog" open={dialogState.open} onClose={handleClose}>
      <DialogTitle>
        {dialogState.positive
          ? "What did you like about this response?"
          : "How could this response be better?"}
      </DialogTitle>
      <DialogContent>
        <TextField
          className="dialog-textField"
          autoFocus
          margin="dense"
          id="feedback"
          label={
            dialogState.positive
              ? "Tell us what you liked"
              : "Tell us what could improve"
          }
          type="text"
          fullWidth
          multiline
          rows={4}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className="dialog-button dialog-buttonCancel"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className="dialog-button dialog-buttonSubmit"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog;
